import { useProps } from "contexts/PropsContext"

import { formatDateInTimezone, formatDateTimeInTimezone, formatInTimezone } from "util/date"

/**
 * Hook to get timezone-aware formatting functions using the admin's configured timezone.
 */
export function useTimezone() {
  const { timezone } = useProps()

  return {
    timezone,
    formatDate: (date: string | Date) => formatDateInTimezone(date, timezone),
    formatDateTime: (date: string | Date) => formatDateTimeInTimezone(date, timezone),
    formatCustom: (date: string | Date, options: Intl.DateTimeFormatOptions) => formatInTimezone(date, timezone, options)
  }
}
